export default __webpack_public_path__ + "static/home1-aefa37d49f3439ba0aef789d35f06088.jpg";